import React, { useState } from "react";
import "../style/PartnersSection.css";

const partnerGroups = [
  {
    category: "State Government",
    icon: "🏛",
    color: "#e8f0fe",
    partners: [
      { name: "State of Ohio" },
    ],
  },
  {
    category: "Industry Partners",
    icon: "🏢",
    color: "#fce4ec",
    partners: [
      { name: "Kroger" },
      { name: "Altafiber" },
      { name: "Fifth Third Bank" },
      { name: "Encore Technologies" },
      { name: "US Bank" },
    ],
  },
  {
    category: "Education Partners",
    icon: "🎓",
    color: "#e8f5e9",
    partners: [
      { name: "Northern Kentucky University" },
      { name: "Wright State University" },
      { name: "Walnut Hills High School" },
      { name: "Middletown High School" },
      { name: "Lakota Cyber Academy" },
    ],
  },
  {
    category: "OCRI",
    icon: "🛡",
    color: "#ede7f6",
    partners: [
      { name: "Ohio Cyber Range Institute" },
    ],
  },
];

const PartnerCard = ({ group }) => {
  const [expanded, setExpanded] = useState(group.category === "State Government");
  return (
    <div
      className="partner-card"
      style={{ backgroundColor: group.color }}
      onClick={() => setExpanded(!expanded)}
    >
      <div className="partner-card-header">
        <div className="partner-card-label">
          <span className="partner-card-icon">{group.icon}</span>
          <span className="partner-card-category">{group.category}</span>
        </div>
        <span className={`partner-card-arrow ${expanded ? "expanded" : ""}`}>{expanded ? "▼" : "▶"}</span>
      </div>
      {expanded && (
        <ul className="partner-card-list">
          {group.partners.map((partner, pIndex) => (
            <li key={pIndex}>{partner.name}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

const PartnersSection = () => {
  return (
    <section className="partners-wrapper" id="partners">
      <h2 className="partners-title">Our Partners</h2>
      <div className="partners-grid">
        {partnerGroups.map((group, gIndex) => (
          <PartnerCard key={gIndex} group={group} />
        ))}
      </div>
    </section>
  );
};

export default PartnersSection;
